
  export default {
    props: {
      ticketId: {
        type: String,
        default: '000000'
      },
      vehicleImage: {
        type: String,
        default: "@/assets/img/placeholders/activity/activity-slider-placeholder.svg"
      },
      vehicleName: {
        type: String,
        default: 'Vehicle Name'
      },
      vehicleLocation: {
        type: String,
        default: 'Location'
      },
      noOfVehicle: {
        type: Number,
        default: '0'
      },
      fromDate: {
        type: String,
        default: '0'
      },
      fromTime: {
        type: String,
        default: '0'
      },
      toDate: {
        type: String,
        default: '0'
      },
      toTime: {
        type: String,
        default: '0'
      },
      contactNumberNo: {
        type: String
      },
      merchantName: {
        type: String
      },
      merchantLandmark: {
        type: String
      },
      orderId: {
        type: String
      },
      statusCode: {
      type: Number,
      default: 1
    },
    qrCode: {
      type: String
    },
    redeemed: {
      type: Boolean
    },
    redeemedDate: {
      type: String
    }, 
    },
    methods:{
    checkStatusCodeValid(code){
      if(code == 2 || code == 3){
        return false
      }
      return true
    }
  }

  }

